<template>
  <page-main>
    <div class="container">
      <div class="page-border">
        <query v-model="query" syear semester keyword="編號、名稱、地點"></query>
        <btn-group :load="reload"></btn-group>
      </div>
      <div class="page-border">
        <table class="table">
          <thead>
            <tr>
              <th>學年度-學期</th>
              <th>編號-名稱</th>
              <th>日期</th>
              <th>社團名稱</th>
              <th>狀態</th>
              <th>送達時間</th>
              <th>下載</th>
            </tr>
          </thead>
          <tr v-for="item in tableData.value" :key="item.CommunityActivityApplicationID">
            <td data-th="學年度-學期">
              {{ item.SYear }}-{{ item.Semester | semester }}
            </td>
            <td data-th="編號-名稱">
              <b-button size="sm" variant="link" @click="edit(item.CommunityActivityApplicationID)">{{ item.No }}-{{
                item.Name }}</b-button>
            </td>
            <td data-th="日期">
              {{ item.StartDay | date("yyyy/mm/dd") }} -
              {{ item.EndDay | date("yyyy/mm/dd") }}
            </td>
            <td data-th="社團名稱">{{ item.CommunityNm }}</td>
            <td data-th="狀態">
              {{ item.ApprovedNm
              }}<span v-if="item.Suggestion">-{{ item.Suggestion }}</span>
            </td>
            <td data-th="送達時間">
              {{ item.ArrivedAdminDate | date("yyyy/mm/dd hh:MM") }}
            </td>
            <td data-th="下載">
              <div class="btn btn-info" v-if="item.Approved == 'Y'"
                @click="download(item.CommunityActivityApplicationID)">下載</div>
              <div class="btn btn-info" v-if="item.Approved == 'Y'"
                @click="downloadEn(item.CommunityActivityApplicationID)">Download</div>
            </td>
          </tr>
        </table>

        <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
      </div>
    </div>
    <Detail id="info" :modalkey="modalkey" @reload="reload"> </Detail>
  </page-main>
</template>

<script>
import Detail from "./communityactivityapplicationDetail.vue";
import { master } from "@/views";
export default master({
  name: "communityactivityapplication",
  api: "/api/communityactivityapplicationreview/",
  components: { Detail },
  methods: {
    download: function (id) {
      window.open(this.$apiurl + 'api/communityactivityapplication/Download/' + id);
    },
    downloadEn: function (id) {
      window.open(this.$apiurl + 'api/communityactivityapplication/DownloadEn/' + id);
    }
  }
});
</script>

<style></style>
